// @flow

import React, { Component } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

import Toggler from '../../../components/UI/Toggler';

type Props = {
  onChange: Function,
};

const roles = [
  {
    title: 'Trekker',
    role: 'trekker',
  },
  {
    title: 'Leader',
    role: 'leader',
  },
  {
    title: 'Lodge Owner',
    role: 'lodge_owner',
  },
  {
    title: 'Super User',
    role: 'superuser',
  },
  {
    title: 'Patron',
    role: 'patron',
  },
  {
    title: 'clear all',
    role: '',
  },
];

export default class ActionsDropdown extends Component<Props> {
  handleDropdownItemClick = e => {
    const role = e.target.name;
    if (role === 'clear all') return this.props.onChange('');
    this.props.onChange(role);
  };

  render() {
    return (
      <Toggler>
        {({ on, toggle }) => (
          <Dropdown isOpen={on} toggle={toggle} className="role-dp">
            <DropdownToggle caret>Roles</DropdownToggle>
            <DropdownMenu>
              {roles.map(role => (
                <DropdownItem
                  key={role.role}
                  name={role.role}
                  onClick={this.handleDropdownItemClick}
                >
                  {role.title}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </Dropdown>
        )}
      </Toggler>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/Admin/UsersPanel/RolesDropdown.jsx